
import { Button } from "@/components/ui/button";
import { LucideIcon } from "lucide-react";

interface PostActionButtonProps {
  icon: LucideIcon;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  count?: number;
  showCount?: boolean;
  isComment?: boolean;
}

export const PostActionButton = ({
  icon: Icon,
  onClick,
  disabled,
  className = "",
  count,
  showCount = true,
  isComment = false
}: PostActionButtonProps) => {
  if (!Icon) return null;

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={onClick}
      disabled={disabled}
      className={`${isComment ? 'bg-white text-corporate-black hover:bg-corporate-gray-100' : 'text-gray-400 hover:text-white'} p-1 h-8 ${className}`}
    >
      <Icon className="h-4 w-4" />
      {showCount && count !== undefined && count > 0 && (
        <span className="ml-1 text-xs">{count}</span>
      )}
    </Button>
  );
};
